import * as React from 'react';
import PropTypes from 'prop-types';

function ArrowDown({ fill, className }) {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 30 30"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <title>Icon/Arrow/Down</title>
      <path
        stroke={fill || '#6E7682'}
        d="M25.5 9.5l-11 11-11-11"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
    </svg>
  );
}

export default ArrowDown;

ArrowDown.defaultProps = {
  fill: '#6E7682',
  className: '',
};

ArrowDown.propTypes = {
  fill: PropTypes.string,
  className: PropTypes.string,
};
